export const UNAUTHORIZED_PRINT_STORE_FALLBACK_LINK =
  'https://www.flowcode.com/blog/printing-your-flowcode'
